const trades = ["Quad", "Buggy", "Jet-ski", "Nautisme", "Excursions", "Surf", "Plongée", "Karting", "Tours", "Loisirs"];

const MetiersMarquee = () => (
  <section data-testid="metiers-marquee" className="border-y border-slate-200/70 bg-white py-6" aria-label="Activités compatibles">
    <div className="mask-fade-x overflow-hidden">
      <div className="animate-marquee flex w-max items-center gap-8 pr-8">
        {[...trades, ...trades].map((t, i) => (
          <span key={`${t}-${i}`} className="flex items-center gap-8 whitespace-nowrap">
            <span className="text-sm font-bold uppercase tracking-[0.2em] text-navy/35">{t}</span>
            <span className="h-1 w-1 rounded-full bg-turquoise" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default MetiersMarquee;
